<template>
  <v-dialog
    v-model="dialog"
    width="500"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <v-card>
      <v-card-title class="amber darken-1 white--text"
        >Thêm mới Showcase
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <showcase-info-form :showcase="selectedShowcase" isEditing ref="form" />
      <v-card-actions class="pr-4 pb-8">
        <v-spacer />
        <v-btn class="px-4" color="primary" @click="save" :loading="loading"
          >Lưu</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ShowcaseInfoForm from '@/components/basic/form/ShowcaseForm.vue'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    ShowcaseInfoForm,
  },
  props: {
    state: Boolean,
    major: Object,
    course: Object,
    selectedShowcase: Object,
  },
  data() {
    return {
      dialog: false,
      loading: false,
    }
  },
  computed: {
    ...mapState('app', ['roles', 'department']),
    ...mapState('auth', ['user']),
    addButtonText() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'Thêm Mới Showcase'
      }
    },
  },
  methods: {
    ...mapActions('showcases', ['updateShowcase', 'upload', 'fetchShowcases']),
    async save() {
      this.loading = true
      let form = this.$refs.form
      let data = form.getData()
      if (form.validate()) {
        let showcase = await this.updateShowcase({
          id: this.selectedShowcase.id,
          ...data,
          data: { link: data.embed },
          image: data.file ? [] : this.selectedShowcase.image,
        })
        if (data.file) {
          await this.upload({
            showcaseId: this.selectedShowcase.id,
            file: data.file,
          })
        }
        console.log(showcase)
        await this.fetchShowcases({})
        this.dialog = false
      }
      this.loading = false
    },
    cancel() {
      this.$emit('close')
    },
  },
  watch: {
    state(state) {
      this.dialog = state
    },
    dialog(dialog) {
      if (!dialog) this.$emit('close')
    },
  },
}
</script>
